import React from 'react'
import { Link } from 'react-router-dom'
import { SolidButton } from '../../../library/button'

const Index = ({errorMessage}) => {
    return(
        <div className="failed-container">
            <h1 className="failed-icon">{errorMessage.icon}</h1>
            <h3 className="failed-title">{errorMessage.title}</h3>
            <p className="failed-description">{errorMessage.description}</p>
            <Link to="/dashboard/oversikt"><SolidButton size="regular" color="blue" title="Gå til dashboard"/></Link>
        </div>
    )
}

export default Index